import { ReactNode } from 'react';
import { styled } from '@mui/material';

import { Header } from './components/Header';
import { Content } from './components/Content';
import { Subheader } from './components/Subheader';
import { SectionHeader } from './components/SectionHeader';

export type PageProps = {
  children: ReactNode;
  className?: string;
};

const StyledPage = styled('div')({
  width: '100%',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
});

export const Page = ({ children, className }: PageProps) => {
  return <StyledPage className={className}>{children}</StyledPage>;
};

Page.Header = Header;
Page.Subheader = Subheader;
Page.SectionHeader = SectionHeader;
Page.Content = Content;
